module.exports = __webpack_public_path__ + "img/k12.b3aa1382.png";